import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { EquippedSlots } from "../pages/ProfilePage/types/profilePageTypes";

export interface ProfileDataState {
  equippedSlots: EquippedSlots | null;
  rank: number | null;
  rankUserId: string | null;
}

const initialState: ProfileDataState = {
  equippedSlots: null,
  rank: null,
  rankUserId: null,
};

export interface SetRankPayload {
  rank: number | null;
  userId: string | null;
}

const profileDataSlice = createSlice({
  name: "profileData",
  initialState,
  reducers: {
    setEquippedSlots: (state, action: PayloadAction<EquippedSlots | null>) => {
      state.equippedSlots = action.payload;
    },
    setRank: (state, action: PayloadAction<SetRankPayload>) => {
      state.rank = action.payload.rank;
      state.rankUserId = action.payload.userId;
    },
    resetProfileData: (state) => {
      state.equippedSlots = null;
      state.rank = null;
      state.rankUserId = null;
    },
  },
});

export const { setEquippedSlots, setRank, resetProfileData } =
  profileDataSlice.actions;
export default profileDataSlice.reducer;
